import { Button, Col, Container, Row, TextInput, Icon } from 'react-materialize';
import Modal from './modal';
import React from 'react';
import { ErpConnect as qad } from '../../../services/index.js';
import LoadingView from '../loading/loading.view';
import Swal from 'sweetalert2';
import AsyncSelect from 'react-select/async';
import axios from 'axios';

class ModalCheckin extends React.Component {

  constructor(props) {
    
    
    super(props);
    const user = JSON.parse(localStorage.getItem('user')) || {};   
     //user.departamentId = '004';
    this.state = {
      date: new Date(new Date().toLocaleString('en', {timeZone: 'America/Monterrey'})), 
      checkinsByStatus: {},
      checkinsDuplex: [],
      advancingTurnos: {},
      loadingTick: false,
      warehouseAgents: [],
warehouseAgentsSite: null,

      hideUpdateButton: false,
      loading: false,
      updateMiliseconds : 1000,
      statuses: [],
      cancelReasons: [],
      user,
      searchQuery: '',
      clientePasaMode: false,
      checkinsByStatusAg: {},     
checkinsDuplexAg: [[], []], 
      editingAgentRowId: null,
      actionLoading: false,   
  savingOrders: false,
  editingAgentStatus: null,
  editingAgentOption: null,
  scheduledSticky: {},
      agendadoCustomer: '',
      agendadoPedido: '',
      loadingAgendado: false,
      agendadoStatus: 'agendado',
    };
  }



getUserLogin = () => {
  const u = this.state?.user || {};
  return String(u.username || u.user || u.name || '').toLowerCase();
};

isClientePasaUser = () => {
  const login = this.getUserLogin();
  const u = this.state?.user || {};
  const site = String(u.site || u.siteId || u.site_id || '').trim();
  const dept = String(u.departmentId || '').trim();
  const isClientePasaLogin = (login === 'trangel' || login === 'asolis');
  const isCDMXAlmacen = (dept === '007' && site === '3100');
  return isClientePasaLogin || isCDMXAlmacen;
};

handleToggleClientePasa = () => {
  this.setState(prev => ({ clientePasaMode: !prev.clientePasaMode }));
};



  startEditAgent = (row) => {
    const currentId = row['usr_' + row.status] ?? null;
    const currentOption = currentId
      ? this.agents.find(a => String(a.value) === String(currentId)) || null
      : null;
  
    this.setState({
      editingAgentRowId: row.id,
      editingAgentStatus: row.status,
      editingAgentOption: currentOption,
    });
  };
  
  cancelEditAgent = () => {
    this.setState({
      editingAgentRowId: null,
      editingAgentStatus: null,
      editingAgentOption: null,
    });
  };
  
  TERMINAL_SCHEDULED = new Set(['delivered','reviewed','entregado']);

isScheduled = (c) => {
  return !!String(c?.usr_agendado || '').trim();
};

isTerminalScheduled = (c) => {
  return this.TERMINAL_SCHEDULED.has(String(c?.status || '').toLowerCase());
};

saveAgent = async (row) => {
  const status = this.state.editingAgentStatus;
  const agentId = this.state.editingAgentOption ? this.state.editingAgentOption.value : null;
  const agentName = this.state.editingAgentOption ? this.state.editingAgentOption.label : '';

  try {
    const res = await axios.put(`/api/checkin/${row.id}`, {
      status: row.status,
      salesPersonId: agentId || '',
      salesPersonName: agentName || '',   
      departmentId: this.state.user.departmentId,
      onlyAgent: true
    });

    if (!res.data || res.data.error) {
      throw new Error(res.data?.message || 'Error guardando agente');
    }

    row['usr_' + status] = agentId || null;
    row['usr_' + status + '_name'] = agentName || null; 

    this.setState({
      editingAgentRowId: null,
      editingAgentStatus: null,
      editingAgentOption: null,
    });

    Swal.fire('Listo', 'Agente actualizado', 'success');
    this.handleManualUpdate();

  } catch (e) {
    try {
      await qad.catalog.website.changeCheckinStatus({
        id: row.id,
        status: row.status,
        salesPersonId: agentId || '',
        salesPersonName: agentName || '', 
        salesOrderId: row.erp_order_id || '',
        reasonId: row.reason_id || '',
      });

      row['usr_' + row.status] = agentId || null;
      row['usr_' + row.status + '_name'] = agentName || null;

      this.cancelEditAgent();
      Swal.fire('Listo', 'Agente actualizado', 'success');
      this.handleManualUpdate();
    } catch (err2) {
      console.error(err2);
      Swal.fire('Error', 'No se pudo actualizar el agente', 'error');
    }
  }
};
  

getStatusStartAt = (row) => {
  const s = String(row?.status || '').toLowerCase();
  if (row?.status_timestamp) return row.status_timestamp;
  if (s === 'order_created') {
    return row.order_created_at || row.creating_order_at || row.arrive_at || row.created_at || null;
  }
  if (s === 'paying') {
    return row.paying_at || row.order_created_at || row.creating_order_at || row.arrive_at || row.created_at || null;
  }
  if (s === 'agendado') {
    return row.agendado_at || row.created_at || null;
  }
  if (s === 'paused') {
    return row.updated_at || row.created_at || null;
  }

  const field = `${s}_at`;
  return row[field] || row.updated_at || row.created_at || null;
};
toLocalDate = (s) => {
  if (!s) return null;
  if (s instanceof Date) return isNaN(s) ? null : s;
  const normalized = typeof s === 'string' && s.indexOf('T') === -1 ? s.replace(' ', 'T') : s;
  let d = new Date(normalized);
  if (!isNaN(d)) return d;
  const m = /^(\d{4})-(\d{2})-(\d{2})[ T](\d{2}):(\d{2}):(\d{2})$/.exec(String(s));
  if (m) {
    return new Date(
      Number(m[1]), Number(m[2]) - 1, Number(m[3]),
      Number(m[4]), Number(m[5]), Number(m[6])
    );
  }
  return null;
};
minutesSince = (startStr) => {
  const start = this.toLocalDate(startStr);
  if (!start) return 0;
  const now = new Date(new Date().toLocaleString('en', { timeZone: 'America/Monterrey' }));
  return Math.max(0, Math.floor((now - start) / 60000));
};

  
handleCloseModal = () => {
  this.props.onClose();
};
    
  
getUserSite = () => {
  const u = this.state?.user || {};
  const raw =
    u?.site ||
    u?.siteId ||
    u?.site_id ||
    u?.pickup_branch ||
    u?.branch ||
    u?.store ||
    u?.sucursal ||
    '';

  const s = String(raw).trim();
  const m = s.match(/\b(3000|3100)\b/);
  return m ? m[1] : s; 
};

ensureWarehouseAgents = async () => {
  const dept = String(this.state?.user?.departmentId || '').trim();
  if (dept !== '007') return;

  const siteRaw = this.getUserSite();
  const site = String(siteRaw || '').match(/\b(3000|3100)\b/)?.[1];
  if (!site) return;

  if (
    this.state.warehouseAgentsSite === site &&
    Array.isArray(this.state.warehouseAgents) &&
    this.state.warehouseAgents.length
  ) {
    return;
  }

  const user = this.state?.user || {};
  const userLogin = String(user?.user || user?.username || user?.usr || user?.name || '')
    .trim()
    .toLowerCase();

  try {
    const { data } = await axios.get('/api/warehouse-agents/options', {
      params: { site },
      headers: {
        'x-user-login': userLogin,
        'x-user-department': String(user?.departmentId || user?.department_id || '').trim(),
        'x-user-site': site,
      },
      withCredentials: true,
    });

    const arr = Array.isArray(data) ? data : (data?.data || []);
    this.setState({ warehouseAgents: arr, warehouseAgentsSite: site });
  } catch (e) {
    console.error('[ensureWarehouseAgents] error', e);
    this.setState({ warehouseAgents: [], warehouseAgentsSite: site });
  }
};

loadWarehouseAgentsOptions = async (inputValue = '') => {
  const siteRaw = this.getUserSite();
  const site = String(siteRaw || '').match(/\b(3000|3100)\b/)?.[1];
  if (!site) return [];

  const q = String(inputValue || '').trim();

  const user = this.state?.user || {};
  const userLogin = String(user?.user || user?.username || user?.usr || user?.name || '')
    .trim()
    .toLowerCase();

  try {
    const { data } = await axios.get('/api/warehouse-agents/options', {
      params: { site, q },
      headers: {
        'x-user-login': userLogin,
        'x-user-department': String(user?.departmentId || user?.department_id || '').trim(),
        'x-user-site': site,
      },
      withCredentials: true,
    });

    const arr = Array.isArray(data) ? data : (data?.data || []);
    return arr.map(a => ({
      label: a.name,
      value: a.sales_person_id || a.salesPersonId || a.code || a.id,
      departmentId: String(a.department_id || a.departmentId || '007')
    }));
  } catch (e) {
    console.error('[loadWarehouseAgentsOptions] error', e);
    return [];
  }
};

  async tick() {
    this.setState({ loadingTick: true });
    const username = this.getUserLogin();
    try {
      if (this.state.statuses.length <= 0) {
        const statuses = await qad.catalog.website.getStatuses();
        if (Array.isArray(statuses)) {
          const idx = statuses.findIndex(s => String(s.status).toLowerCase() === 'agendado');
          if (idx === -1) {
            statuses.push({
              status: 'agendado',
              label: 'Agendado',
              next_status: 'payed',
              bgcolor_status: '#6c5ce7',
              bgcolor_order: '#ecf0f1',
              departaments: ['001','002','003','004','005','006','007']
            });
          } else {
            statuses[idx].next_status = statuses[idx].next_status || 'payed';
            statuses[idx].label       = statuses[idx].label || 'Agendado';
          }
          this.setState({ statuses });
        }
      }
  
      if (this.state.cancelReasons.length <= 0) {
        const cancelReasons = await qad.catalog.website.getCancelReasons();
        const cancelReasonsForSelect = {};
        cancelReasons.forEach((item) => { cancelReasonsForSelect[item.id] = item.name; });
        this.setState({ cancelReasons: cancelReasonsForSelect });
      }
      const site = this.getUserSite();        
      const deptId = String(this.state.user?.departmentId || '').trim();
      const isCDMX007 = (deptId === '007' && site === '3100');
      
      if (!site) {
        console.warn('[tick] sin site válido:', this.state.user);
        this.setState({ loadingTick: false });
        return;
      }
      
      await this.ensureWarehouseAgents();         
      
      const payload = await qad.catalog.website.getCheckinsByStatus({ site });
        
      if (payload.length > 0) {
        
        
        let fullCheckins = [];
        let filteredCheckinsByStatus = {};
        const raw = payload[0] || {};
          this.state.statuses.forEach((row) => {
          const status = row.status;
          const checkins = raw[status] || [];
  
          if (row.departaments.includes(this.state.user.departmentId) || ['asolis','trangel'].includes(username)) {
            const filtered = checkins.filter((c) => {
              if (c.status === 'paused') {
                const isPinned =
                  (c.is_pinned === 1 || c.is_pinned === true) ||
                  (typeof c.paused_comment === 'string' && c.paused_comment.toLowerCase().includes('agendado'));
                if (isPinned) return true;
                if (['001','002'].includes(this.state.user.departmentId)) return true;
                return Number(c.paused_department_id) === Number(this.state.user.departmentId);
              }
              return true;
            });
  
            filteredCheckinsByStatus[status] = filtered;
            fullCheckins = fullCheckins.concat(filtered);
          }
        });
  
        fullCheckins = fullCheckins.map((c) => {
          const q = Number(c?.quantity);
          return { ...c, quantity: Number.isFinite(q) ? q : 1 };
        });
          
        let sticky = { ...(this.state.scheduledSticky || {}) };
  
        const presentIds = new Set();
        Object.keys(filteredCheckinsByStatus).forEach(st => {
          (filteredCheckinsByStatus[st] || []).forEach(c => presentIds.add(Number(c.id)));
        });
  
        Object.keys(raw).forEach(st => {
          (raw[st] || []).forEach(c => {
            const terminal = this.isTerminalScheduled(c);
            if (!this.isScheduled(c) || terminal) {
              delete sticky[c.id];
            } else {
              sticky[c.id] = c; 
            }
          });
        });
  
        Object.keys(sticky).forEach(id => {
          if (!presentIds.has(Number(id))) {
            delete sticky[id];
          }
        });
  
        Object.values(sticky).forEach(c => {
          if (this.isTerminalScheduled(c)) return;
          const bucket = c.status;
          if (!filteredCheckinsByStatus[bucket]) filteredCheckinsByStatus[bucket] = [];
          if (!filteredCheckinsByStatus[bucket].some(x => x.id === c.id)) {
            filteredCheckinsByStatus[bucket].push(c);
          }
          if (!fullCheckins.some(x => x.id === c.id)) {
            fullCheckins.push(c);
          }
        });
const onlyAgendados = fullCheckins.filter(
  (c) => this.isScheduled(c) && !this.isTerminalScheduled(c)
);
const onlyNormales = fullCheckins.filter((c) => !this.isScheduled(c));
const byStatusAg = {};
const byStatusNorm = {};
Object.keys(filteredCheckinsByStatus).forEach((st) => {
  const arr = filteredCheckinsByStatus[st] || [];
  byStatusAg[st] = arr.filter(
    (c) => this.isScheduled(c) && !this.isTerminalScheduled(c)
  );
  byStatusNorm[st] = arr.filter((c) => !this.isScheduled(c));
});
const buildDuplex = (rows) => {
  const source = Array.isArray(rows) ? rows : [];

  if (isCDMX007) return [source.slice(0, 23), source.slice(23)];

  if (username === 'asolis') {
    const filtered = source.filter(c => Number(c.quantity) <= 20);
    return [filtered.slice(0, 23), filtered.slice(23)];
  }

  if (username === 'trangel') {
    const filtered = source.filter(c => Number(c.quantity) > 20);
    return [filtered.slice(0, 23), filtered.slice(23)];
  }

  return [
    source.filter(c => Number(c.quantity) <= 20),
    source.filter(c => Number(c.quantity) > 20),
  ];
};

const checkinsDuplexNormals = buildDuplex(onlyNormales);
const checkinsDuplexAgendados = buildDuplex(onlyAgendados);

this.setState({
  checkinsByStatus: byStatusNorm,
  checkinsDuplex: checkinsDuplexNormals,
  checkinsByStatusAg: byStatusAg,
  checkinsDuplexAg: checkinsDuplexAgendados,

  scheduledSticky: sticky,
  loading: false,
});
      }
      this.setState({
        date: new Date(new Date().toLocaleString('en', { timeZone: 'America/Monterrey' })),
        loading: false
      });
  
    } catch (err) {
      this.setState({
        date: new Date(new Date().toLocaleString('en', { timeZone: 'America/Monterrey' })),
        loading: true
      });
  
    } finally {
      this.setState({ loadingTick: false });
    }
  }        

  async togglePause(row, index) {
    const isPaused = row.status === 'paused';
    let nextStatus = isPaused ? row.previous_status : 'paused';
    let reason = '';
  
    if (!isPaused) {
      const { value: motivo } = await Swal.fire({
        title: '¿Por qué pausas este turno?',
        input: 'radio',
        inputOptions: {
          baño: 'Cliente fue al baño',
          no_responde: 'No responde',
          verificando: 'Está verificando pedido',
          salio: 'Salió de la tienda',
          agendado: 'Pedido agendado'
        },
        inputValidator: (value) => {
          if (!value) return 'Debes seleccionar un motivo';
        },
        confirmButtonText: 'Pausar turno',
        cancelButtonText: 'Cancelar',
        showCancelButton: true,
        width: 700, 
        customClass: {
          input: 'swal-input-radio-custom'
        }
      });
        
      if (!motivo) return; 
  
      reason = motivo;
    }
  
    const result = await qad.catalog.website.changeCheckinStatus({
      id: row.id,
      status: nextStatus,
      salesPersonId: this.state.user.salesPersonId,
      salesPersonName: (this.state.user?.name || this.state.user?.username || ''), 
      departmentId: this.state.user.departmentId,
      salesOrderId: row.erp_order_id || '',
      reasonId: row.reason_id || '',
      previousStatus: isPaused ? null : row.status,
      pauseReason: reason
    });
      
    if (result[0].message) {
      Swal.fire({ title: result[0].message });
      row["hide_action"] = true;
      this.tick();
    }
  }
  getAgentNamePair = (agentId, agentsByKey) => {
    const full = agentId && agentsByKey[String(agentId)]
      ? agentsByKey[String(agentId)].name
      : (agentId || 'Sin Atender');
    const short = full === 'Sin Atender' ? 'Sin Atender' : full.trim().split(/\s+/)[0];
    return { full, short };
  };
  
  

  renderOrderActions(row) {
    const hasComment   = !!(row.comment || row.paused_comment);
    const hasMainOrder = !!String(row.erp_order_id || '').trim();
      if (!hasComment && !hasMainOrder) return null;
  
    const containerStyle = {
      marginTop: 4,
      display: 'flex',
      flexWrap: 'wrap',
      gap: 4,
    };
  
    const baseBtnStyle = {
      height: 22,               
      lineHeight: '22px',
      padding: '0 6px',         
      fontSize: 11,              
      borderRadius: 999,
      display: 'inline-flex',
      alignItems: 'center',
      justifyContent: 'center',
      textTransform: 'uppercase',
    };
  
    const viewStyle = {
      ...baseBtnStyle,
      backgroundColor: '#009688', 
    };
  
    const editStyle = {
      ...baseBtnStyle,
      backgroundColor: '#546e7a', 
    };
  
    const iconStyle = {
      fontSize: 14,
      marginRight: 4,
    };
  
    return (
      <div className="order-actions" style={containerStyle}>
        <Button
          node="button"
          small
          waves="light"
          style={viewStyle}
          onClick={() => this.showGroupedOrders(row)}
        >
          <Icon tiny left style={iconStyle}>list_alt</Icon>
          VER
        </Button>
  
        {this.canEditOrders() && (
          <Button
            node="button"
            small
            waves="light"
            style={editStyle}
            onClick={() => this.openEditOrders(row)}
          >
            <Icon tiny left style={iconStyle}>edit</Icon>
            EDITAR
          </Button>
        )}
      </div>
    );
  }
    

  showGroupedOrders = (row) => {
    const primary = String(row.erp_order_id || '').toUpperCase();

    const comment = String(row.comment || row.paused_comment || '').trim();

    if (!comment && !primary) {
      Swal.fire('Pedidos', 'No hay pedidos registrados para este turno.', 'info');
      return;
    }
    const cleaned = comment.replace(/^pedidos[^:]*:/i, '');

    let pedidos = cleaned
      .split(/[^A-Z0-9]+/i)
      .map(p => p.trim().toUpperCase())
      .filter(p => p.length > 0 && /\d/.test(p));
    if (primary && !pedidos.includes(primary)) {
      pedidos.unshift(primary);
    }

    if (!pedidos.length) {
      Swal.fire('Pedidos', primary ? `<b>${primary}</b>` : 'No hay pedidos adicionales', 'info');
      return;
    }

    Swal.fire({
      title: `Pedidos del turno #${row.turn}`,
      html: `
        <div style="text-align:left;margin-bottom:10px;">
          <div><b>Cliente:</b> ${row.name || 'Sin nombre'}</div>
          <div><b>Cantidad total:</b> ${row.quantity != null ? row.quantity : 'Sin cantidad'}</div>
        </div>
        <hr style="margin:8px 0;">
        <ul style="text-align:left;margin:0;padding-left:18px;">
          ${pedidos.map(p => `<li><b>${p}</b></li>`).join('')}
        </ul>
      `,
      confirmButtonText: 'Cerrar'
    });
  };    

  canEditOrders = () => {
    const u = this.state?.user || {};
    const username = String(u.username || u.user || u.name || '').toLowerCase();
    const dept     = String(u.departmentId || '');
    const isCajasOrDept004 = ['004'].includes(dept);
    const isAlmacenUser = ['asolis', 'trangel','ejimenez'].includes(username) && dept === '007';
return isCajasOrDept004 || isAlmacenUser;
};
openEditOrders = async (row) => {
  try {
      const resp = await axios.get(`/api/checkin/${row.id}/orders`);
      const payload = resp?.data?.result?.[0]?.data?.[0] || {};
      const currentOrders = Array.isArray(payload.orders) ? payload.orders : [];
      const currentMain   = payload.main_erp || row.erp_order_id || (currentOrders[0] || '');
  
      const { isConfirmed, value } = await Swal.fire({
        title: `Editar pedidos del turno #${row.turn}`,
        html: `
          <div style="text-align:left">
            <label><b>Pedido principal</b></label>
            <input id="sw-main-erp" class="swal2-input" placeholder="Ej. P303351" value="${currentMain || ''}">
            <label style="margin-top:8px"><b>Pedidos (separados por coma o salto de línea)</b></label>
            <textarea id="sw-orders" class="swal2-textarea" placeholder="P303351, P303424, P303348">${currentOrders.join(', ')}</textarea>
          </div>
        `,
        showCancelButton: true,
        confirmButtonText: 'Guardar',
        cancelButtonText: 'Cancelar',
        focusConfirm: false,
        preConfirm: () => {
          let main_erp = (document.getElementById('sw-main-erp').value || '').toUpperCase().trim();
          let listRaw  = (document.getElementById('sw-orders').value || '').toUpperCase();
          let orders   = listRaw.split(/[,\n\r; ]+/).map(s => s.trim()).filter(Boolean);
  
          if (main_erp && !orders.includes(main_erp)) orders.unshift(main_erp);
          orders = Array.from(new Set(orders)).filter(s => s.length >= 6);
          if (!main_erp && orders.length) main_erp = orders[0];
  
          if (!orders.length) {
            Swal.showValidationMessage('Debes capturar al menos un pedido válido (mín. 6 caracteres).');
            return false;
          }
          return { main_erp, orders };
        }
      });
        if (!isConfirmed) return;
        this.setState({ savingOrders: true, actionLoading: true });
  
      const save = await axios.put(`/api/checkin/${row.id}/orders`, value);
      const saved = save?.data?.result?.[0]?.data?.[0];
      const newMain = saved?.main_erp || value.main_erp;
      const list    = saved?.orders || value.orders;
        row.erp_order_id = newMain || '';
      row.comment      = list?.length ? `Pedidos: ${list.join(', ')}` : null;
      if (typeof saved?.quantity === 'number') {
        row.quantity = saved.quantity;
      }
  
      Swal.fire('Listo', 'Pedidos actualizados correctamente', 'success');
      this.handleManualUpdate();
    } catch (e) {
      console.error(e);
      Swal.fire('Error', 'No se pudo editar los pedidos. Intenta nuevamente.', 'error');
    } finally {
      this.setState(prev => ({
        savingOrders: false,
        actionLoading: Object.values(prev.advancingTurnos || {}).some(Boolean),
      }));
    }
  };
  

  canEditAgent = (row) => {
    const u = this.state?.user || {};
    const dept = String(u.departmentId || '').trim();
    const login = this.getUserLogin();
      if (dept === '007') return true;
    if (dept === '002') return true; 
      if (['asolis', 'trangel'].includes(login)) return true;
  
    return false;
  };
  
  async setAgent(row, index, agent, status) {
    const value = agent ? agent.value : null;
    const name  = agent ? agent.label : null;
  
    row["usr_" + status] = value;
    row["usr_" + status + "_name"] = name; 
  }
  
  async nextStep(row, index, nextStatus) {
    if (row.status === 'paying' && nextStatus !== 'canceled') {
      const { value: next } = await Swal.fire({
        title: '¿A dónde quieres avanzar?',
        input: 'radio',
        inputOptions: {
          order_received: 'Pagado',
          transferencia: 'Transferencia',
          consolidar: 'Consolidar pedido',
        },
        inputValidator: (value) => {
          if (!value) return 'Debes seleccionar una opción';
        },
        confirmButtonText: 'Continuar',
        cancelButtonText: 'Cancelar',
        showCancelButton: true,
      });
  
      if (!next) return;
  
      if (next === 'consolidar') {
        const { value: newOrderId } = await Swal.fire({
          title: 'Nuevo pedido consolidado',
          input: 'text',
          inputPlaceholder: 'Ej. PC52',
          inputValidator: (value) => {
            if (!value || !value.toUpperCase().startsWith("PC")) {
              return 'Debe comenzar con "PC" (Ej. PC52)';
            }
          },
          confirmButtonText: 'Guardar',
          cancelButtonText: 'Cancelar',
          showCancelButton: true,
        });
  
        if (!newOrderId) return;
        row.erp_order_id = newOrderId.toUpperCase();
  
        try {
          const res = await axios.put(`/api/checkin-update-q/${row.id}`, {
            erp_order_id: row.erp_order_id,
            salesPersonId: this.state.user.salesPersonId,
            status: 'payed'
          });
  
          if (!res.data.error) {
            row.quantity = res.data.quantity;
            Swal.fire('Cantidad actualizada', `Se actualizaron ${res.data.quantity} piezas.`, 'success');
          } else {
            Swal.fire('Error', res.data.message, 'error');
          }
        } catch (err) {
          console.error("Error al actualizar cantidad:", err);
          Swal.fire('Error', 'No se pudo actualizar la cantidad del pedido.', 'error');
        }
  
        nextStatus = 'order_received';
      } else if (next === 'transferencia') {
        nextStatus = 'transferencia';
      } else {
        nextStatus = next;
      }
    }
  
    if (row.status === 'transferencia' && nextStatus !== 'canceled') {
      const { value: next } = await Swal.fire({
        title: '¿Qué deseas hacer después de la transferencia?',
        input: 'radio',
        inputOptions: {
          order_received: 'Marcar como Pagado',
          consolidar: 'Consolidar pedido',
        },
        inputValidator: (value) => {
          if (!value) return 'Debes seleccionar una opción';
        },
        confirmButtonText: 'Continuar',
        cancelButtonText: 'Cancelar',
        showCancelButton: true,
      });
  
      if (!next) return;
  
      if (next === 'consolidar') {
        const { value: newOrderId } = await Swal.fire({
          title: 'Nuevo pedido consolidado',
          input: 'text',
          inputPlaceholder: 'Ej. PC52',
          inputValidator: (value) => {
            if (!value || !value.toUpperCase().startsWith("PC")) {
              return 'Debe comenzar con "PC" (Ej. PC52)';
            }
          },
          confirmButtonText: 'Guardar',
          cancelButtonText: 'Cancelar',
          showCancelButton: true,
        });
  
        if (!newOrderId) return;
        row.erp_order_id = newOrderId.toUpperCase();
  
        try {
          const res = await axios.put(`/api/checkin-update-q/${row.id}`, {
            erp_order_id: row.erp_order_id,
            salesPersonId: this.state.user.salesPersonId,
            status: 'payed'
          });
  
          if (!res.data.error) {
            row.quantity = res.data.quantity;
            Swal.fire('Cantidad actualizada', `Se actualizaron ${res.data.quantity} piezas.`, 'success');
          } else {
            Swal.fire('Error', res.data.message, 'error');
          }
        } catch (err) {
          console.error("Error al actualizar cantidad:", err);
          Swal.fire('Error', 'No se pudo actualizar la cantidad del pedido.', 'error');
        }
  
        nextStatus = 'order_received';
      } else {
        nextStatus = next;
      }
    }
  
    if (nextStatus === 'order_created' && (!row.erp_order_id || row.erp_order_id.length < 6)) {
      Swal.fire({ title: "Tienes que agregar pedido al turno para poder continuar" });
      return;
    }
  
    if (
      (nextStatus === 'at_stock' && !row["usr_at_stock"]) ||
      (nextStatus === 'delivered' && !row["usr_delivered"])
    ) {
      Swal.fire({ title: "Tienes que asignar un agente al turno para poder continuar" });
      return;
    }
  
    try {
      const actingId = !row["usr_" + nextStatus]
      ? this.state.user.salesPersonId
      : row["usr_" + nextStatus];
    
    const actingName =
      String(actingId) === String(this.state.user.salesPersonId)
        ? (this.state.user?.name || this.state.user?.username || '')
        : (this.agents?.find(a => String(a.value) === String(actingId))?.label || '');
    
    const result = await qad.catalog.website.changeCheckinStatus({
      id: row.id,
      status: nextStatus,
      salesPersonId: actingId,
      salesPersonName: actingName,  
      salesOrderId: row.erp_order_id || '',
      reasonId: row.reason_id || '',
    });
      
  
      if (result?.[0]?.message) {
        Swal.fire({ title: result[0].message });
  
        const nextLower = String(nextStatus).toLowerCase();
        row.status = nextStatus; 
  
        if (this.isScheduled(row)) {
          this.setState(prev => {
            const sticky = { ...(prev.scheduledSticky || {}) };
            if (this.TERMINAL_SCHEDULED.has(nextLower) || nextLower === 'canceled') {
              delete sticky[row.id];
            } else {
              sticky[row.id] = { ...row };
            }
            return { scheduledSticky: sticky };
          });
        }
  
        this.tick();
      }
    } catch (err) {
      console.error("Error al cambiar estatus:", err);
      Swal.fire({ title: 'Error intente nuevamente' });
    }
  }
  


  handleCreateAgendado = async () => {
    const { agendadoCustomer, agendadoPedido, user } = this.state;
  
    if (!agendadoCustomer.trim() || !agendadoPedido.trim()) {
      Swal.fire('Error', 'Nombre y número de pedido son obligatorios', 'error');
      return;
    }
  
    this.setState({ loadingAgendado: true });
  
    try {
      const payload = {
        name: agendadoCustomer.trim(),
        erp_order_id: agendadoPedido.trim(),
        usr_agendado: user?.username || ''
      };  
      const res = await axios.post('/api/agendado', payload);
  
  
      if (res.data.success) {
        Swal.fire('Éxito', res.data.message || 'Turno agendado creado correctamente', 'success');
  
        this.setState({
          agendadoCustomer: '',
          agendadoPedido: ''
        });
  
        this.tick(); 
      } else {
        Swal.fire('Error', res.data.message || 'No se pudo crear el turno', 'error');
      }
    } catch (err) {
      console.error('[ERROR al crear agendado]:', err);
      Swal.fire('Error', 'Ocurrió un error al registrar el turno', 'error');
    } finally {
      this.setState({ loadingAgendado: false });
    }
  };
  
  
  handleNextStepWithLoading = async (row, rIndex, nextStatus) => {
    const turnoId = row.id;
    if (this.state.advancingTurnos[turnoId]) return;
  
    this.setState(prev => ({
      advancingTurnos: { ...prev.advancingTurnos, [turnoId]: true },
      actionLoading: true,
    }));
  
    try {
      await this.nextStep(row, rIndex, nextStatus);
    } catch (error) {
      console.error('Error al avanzar turno:', error);
    } finally {
      this.setState(prev => {
        const nextMap = { ...prev.advancingTurnos, [turnoId]: false };
        const anyStillRunning = Object.values(nextMap).some(Boolean);
  
        return {
          advancingTurnos: nextMap,
          actionLoading: anyStillRunning, 
        };
      });
    }
  };
  
  handleManualUpdate = () => {
    this.setState({ hideUpdateButton: true }, () => {
      this.tick(); 
  
      setTimeout(() => {
        this.setState({ hideUpdateButton: false });
      }, 5000);
    });
  };
  
  
          
  async cancelStep(row, index)
  {
    const { value: reasonId } = await Swal.fire({
      title: "Razones para la cancelación",
      input: "select",
      inputOptions: this.state.cancelReasons,
      inputPlaceholder: "Selecciona una razón de la cancelación",
      showCancelButton: true,
      inputValidator: (value) => {
        return new Promise((resolve) => {
          if ( value )
          {
            resolve();
          }
          else
          {
            resolve("Se tiene que seleccionar una razón para la cancelación");
          }
        });
      }
    });
    if (reasonId)
    {
      row.reason_id = reasonId;
      this.nextStep(row, index, 'canceled');
    }
  }

  setOrder(row, index, value)
  {
    if ( !value )
    {
      value = '';
    }
    let currentStatus = this.state.checkinsByStatus;
    currentStatus[row.status][index]["erp_order_id"] = value;
    this.setState({
      checkinsByStatus: currentStatus
    });
  }

  promiseOptions = (inputValue) => {
    return new Promise ((resolve) => {
      resolve(this.filterOptions(inputValue));
    });
  }

  filterOptions = (inputValue, slice = 0) => {
    return this.agents.filter((i) => {
        return i.label.toLowerCase().includes(inputValue.toLowerCase())
    });
  }
  render() {
    let agentsByKey = {};
    let deptsByKey = {};
    
    const catalogAgents = Array.isArray(this.props?.catalog?.agents) ? this.props.catalog.agents : [];
    const deptIdForAgents = String(this.state?.user?.departmentId || '').trim();
    
    const sourceAgents = (deptIdForAgents === '007')
      ? (Array.isArray(this.state.warehouseAgents) ? this.state.warehouseAgents : [])
      : catalogAgents;
    
    this.agents = sourceAgents.map((a) => {
      const value = (deptIdForAgents === '007')
        ? (a.sales_person_id || a.salesPersonId || a.code || a.id)
        : a.id;
    
      const label = a.name;
      const deptId = (deptIdForAgents === '007') ? '007' : String(a.departmentId || '');
    
      agentsByKey[String(value)] = { name: label, departmentId: deptId };
    
      return { value, label, departmentId: deptId };
    });
    
    if (deptIdForAgents === '007') {
      this.agents = this.agents.filter(x => String(x.departmentId) === '007');
    }
        
    this.departaments = this.props.catalog.departaments.map((dept) => {
      if ( !deptsByKey[dept.id] )
      {
        deptsByKey[dept.id] = dept;
      }
      return { value: dept.id, label: dept.name };
    });
    if (this.state.user.departmentId === "007") {
      this.agents = this.agents.filter((agent) => agent.departmentId === '007');
    }
    
    const user  = this.state.user || {};
    const login = String(user.username || '').toLowerCase();
    
    const deptId = String(user.departmentId || '').trim();
    const siteId = String(user.site || user.siteId || user.site_id || user.pickup_branch || '').trim();
    
    const isCDMX007 = (deptId === '007' && siteId === '3100');
    const isDept007 = (deptId === '007');
    
    const rowNoGutter007 = { marginLeft: 0, marginRight: 0 };
    const colNoGutter007 = { paddingLeft: 0, paddingRight: 0 };
    
    const center007 = { justifyContent: 'center', textAlign: 'center' };
    
    const cell007 = {
      boxSizing: 'border-box',
      padding: '0 10px',
      minHeight: 44,
      display: 'flex',
      alignItems: 'center',
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      fontSize: 22,     
      fontWeight: 800,  
    };
        
    const cellHeader007 = {
      ...cell007,
      fontSize: 14,
      fontWeight: 900,
      textTransform: 'uppercase',
      letterSpacing: '0.8px',
      opacity: 0.95,
      minHeight: 36,
    };
        
    const headerRow007 = {
      ...rowNoGutter007,
      margin: '0 0 10px 0',
      paddingBottom: 6,
      borderBottom: '2px solid rgba(0,0,0,0.18)',
    };
    
    const turnRow007 = {
      ...rowNoGutter007,
      borderBottom: '1px solid rgba(0,0,0,0.12)', 
      paddingBottom: 10,
      marginBottom: 10,
    };
        
        
    const showOnlyAgendados = this.isClientePasaUser() && this.state.clientePasaMode;

    const checkinsByStatusToUse = showOnlyAgendados
      ? (this.state.checkinsByStatusAg || {})
      : (this.state.checkinsByStatus || {});
    
    const checkinsDuplexToUse = showOnlyAgendados
      ? (this.state.checkinsDuplexAg || [[], []])
      : (this.state.checkinsDuplex || [[], []]);
    
    const query = (this.state.searchQuery || '').trim().toLowerCase();
    const filterFn = (r) => {
      if (!query) return true;
      const name  = String(r.name || '').toLowerCase();
      const order = String(r.erp_order_id || '').toLowerCase();
      return name.includes(query) || order.includes(query);
    };
    
    const checkinsDuplexFiltered = checkinsDuplexToUse.map(col =>
      Array.isArray(col) ? col.filter(filterFn) : []
    );
    
    const isVolumeStyleUser = ['asolis', 'trangel'].includes(login) || isCDMX007;
        const listForRender = isVolumeStyleUser
      ? checkinsDuplexFiltered
      : checkinsDuplexToUse;


      return (
      <React.Fragment>
<Modal
  isOpen={this.props.isOpen}
  onClose={this.handleCloseModal}
>
<Container className="remove-padding">
  <Row>
    <Col s={12}>
<div
  style={{
    display: 'grid',
    gridTemplateColumns: '1fr auto 1fr',
    alignItems: 'center',
    gap: 10,
    marginBottom: 8
  }}
>
  <div style={{ display: 'flex', alignItems: 'center', gap: 10, flexWrap: 'wrap' }}>
    {!this.state.hideUpdateButton && (
      <Button small onClick={this.handleManualUpdate}>
        ACTUALIZAR AHORA
      </Button>
    )}

    {this.isClientePasaUser() && (
      <Button
        small
        className={this.state.clientePasaMode ? 'purple' : 'grey darken-2'}
        onClick={this.handleToggleClientePasa}
      >
        <Icon left>transfer_within_a_station</Icon>
        {this.state.clientePasaMode ? 'Ver todos' : 'Cliente pasa'}
      </Button>
    )}

    {this.state.user.departmentId === '007' && (
      <Button
        small
        className="green"
        onClick={() => this.setState({ showAgendadoInline: true })}
      >
        NUEVO TURNO
      </Button>
    )}
  </div>

  {(['asolis', 'trangel'].includes(login) || isCDMX007) && (
  <div
    style={{
      display: 'flex',
      justifyContent: 'center',
      margin: '10px 0 20px',
    }}
  >
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
        padding: '6px 14px',
        borderRadius: 999,
        backgroundColor: '#fff',
        boxShadow: '0 2px 8px rgba(0,0,0,0.15)',
        width: '100%',
        maxWidth: 420,
      }}
    >
      <Icon small style={{ marginRight: 8, color: '#757575' }}>search</Icon>

      <TextInput
        id="searchCheckins"
        placeholder="Buscar cliente o pedido..."
        value={this.state.searchQuery}
        onChange={(e) => this.setState({ searchQuery: e.target.value })}
        noLayout
        inputClassName="search-input"
        style={{
          margin: 0,
          flex: 1,
          color: '#212121',
          fontSize: 14,
        }}
      />
    </div>
  </div>
)}

  <div />
</div>
{this.state.showAgendadoInline && (
  <div style={{
    marginTop: '1rem',
    backgroundColor: '#f5f5f5',
    padding: '1rem',
    borderRadius: '8px'
  }}>
    <h5>Nuevo Turno Almacén</h5> 
    <div className="row">
      <div className="col s12 m4">
        <label>Nombre del Cliente</label>
        <input
          type="text"
          value={this.state.agendadoCustomer || ''}
          onChange={(e) => this.setState({ agendadoCustomer: e.target.value })}
        />
      </div>
      <div className="col s12 m4">
        <label>Número de Pedido</label>
        <input
          type="text"
          value={this.state.agendadoPedido || ''}
          onChange={(e) => this.setState({ agendadoPedido: e.target.value })}
        />
      </div>
      <div className="col s12 m4">
        <label>Estatus Inicial</label>
        <select
          className="browser-default"
          value={this.state.agendadoStatus}
          onChange={(e) => this.setState({ agendadoStatus: e.target.value })}
        >
          <option value="agendado">Agendado</option>
          <option value="payed">Por Surtir</option>
        </select>
      </div>

      <div className="col s12" style={{ marginTop: '1rem' }}>
        <button
          className="btn green"
          onClick={async () => {
            const {
              agendadoCustomer,
              agendadoPedido,
              agendadoStatus,
              user
            } = this.state;

            if (!agendadoCustomer.trim() || !agendadoPedido.trim()) {
              window.Swal && Swal.fire('Error', 'Nombre y número de pedido son obligatorios', 'error');
              return;
            }

            this.setState({ loadingAgendado: true });

            try {
              const res = await axios.post('/api/agendado', {
                name: agendadoCustomer.trim(),
                erp_order_id: agendadoPedido.trim(),
                usr_agendado: user?.username || '',
                status: agendadoStatus
              });

              if (res.data.success) {
                window.Swal && Swal.fire('Éxito', 'Turno creado correctamente', 'success');
                this.setState({
                  agendadoCustomer: '',
                  agendadoPedido: '',
                  agendadoStatus: 'agendado',
                  showAgendadoInline: false,
                  loadingAgendado: false
                });
                this.handleManualUpdate();
              }
            } catch (err) {
              console.error(err);
              window.Swal && Swal.fire('Error', 'No se pudo crear el turno', 'error');
              this.setState({ loadingAgendado: false });
            }
          }}
          disabled={this.state.loadingAgendado}
        >
          {this.state.loadingAgendado ? 'Guardando...' : 'Guardar'}
        </button>

        <button
          className="btn-flat red-text"
          style={{ marginLeft: '1rem' }}
          onClick={() => this.setState({ showAgendadoInline: false })}
        >
          Cancelar
        </button>
      </div>
    </div>
  </div>
)}

{(this.state.loadingTick || this.state.actionLoading || this.state.savingOrders || this.state.loadingAgendado) &&(
  <div style={{
    position:'fixed',
    top:0,
    left:0,
    width:'100vw',
    height:'100vh',
    backgroundColor:'rgba(255,255,255,0.7)',
    display:'flex',
    flexDirection:'column',
    justifyContent:'center',
    alignItems:'center',
    zIndex:9999
  }}>
    <LoadingView />
    <div style={{ marginTop:'15px', fontSize:'18px', fontWeight:'bold', color:'#333' }}>
      
    <span role="img" aria-label="actualizar">🔄 </span> Cargando información...
      <span ></span>
    </div>
  </div>
)}

<div className="separator" />
{(isCDMX007 || ['asolis','trangel'].includes(login)) && (
      <div style={{
      backgroundColor: '#1a1a1a',
      color: '#ffffff',
      textAlign: 'center',
      padding: '12px',
      fontSize: '18px',
      fontWeight: 'bold',
      marginBottom: '10px',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      gap: '10px'
    }}>
      <Icon style={{ color: '#e74c3c' }}>inventory_2</Icon>
      {
        isCDMX007
          ? 'CDMX'
          : (['almacen1', 'asolis'].includes(login)
              ? 'MENOS DE 20 PIEZAS'
              : 'POR VOLUMEN'
            )
      }
    </div>
  )
}

{!isDept007 && (
  <Row>
    <Col xl={4} l={6} s={12}>
      <Row>
        <Col xl={6} s={5}><div className="status-title-turn">Turnos</div></Col>
        <Col s={3}><div className="status-title-status">Estatus</div></Col>
        <Col xl={3} s={2}><div className="status-title-order">Pedido</div></Col>
        <Col s={2}><div className="status-title-next">Continuar</div></Col>
      </Row>
    </Col>

    <Col className="hide-small" xl={4} l={6} s={12}>
      <Row>
        <Col xl={6} s={5}><div className="status-title-turn">Turnos</div></Col>
        <Col s={3}><div className="status-title-status">Estatus</div></Col>
        <Col xl={3} s={2}><div className="status-title-order">Pedido</div></Col>
        <Col s={2}><div className="status-title-next">Continuar</div></Col>
      </Row>
    </Col>

    <Col className="hide-xlarge" xl={4} l={6} s={12}>
      <Row>
        <Col xl={6} s={5}><div className="status-title-turn">Turnos</div></Col>
        <Col s={3}><div className="status-title-status">Estatus</div></Col>
        <Col xl={3} s={2}><div className="status-title-order">Pedido</div></Col>
        <Col s={2}><div className="status-title-next">Continuar</div></Col>
      </Row>
    </Col>
  </Row>
)}
               

{
  (!this.state.loading)
    ? (
      <Row>
        {
          isVolumeStyleUser
            ? listForRender.map((group, groupIndex) => (
<Col
  key={groupIndex}
  s={6}
  style={{
    ...colNoGutter007,
    borderRight: groupIndex === 0 ? '2px solid rgba(0,0,0,0.18)' : 'none',
    paddingRight: groupIndex === 0 ? 12 : 0,
    paddingLeft: groupIndex === 1 ? 12 : 0,
  }}
>

{isDept007 && (
  <Row style={headerRow007}>
    <Col s={4} style={colNoGutter007}><div style={cellHeader007}>Nombre</div></Col>
    <Col s={1} style={colNoGutter007}><div style={{ ...cellHeader007, ...center007 }}>Turno</div></Col>
    <Col s={3} style={colNoGutter007}><div style={{ ...cellHeader007, ...center007 }}>Estatus</div></Col>
    <Col s={2} style={colNoGutter007}><div style={{ ...cellHeader007, ...center007 }}>Pedido</div></Col>
    <Col s={2} style={colNoGutter007}><div style={{ ...cellHeader007, ...center007 }}>Atiende</div></Col>
  </Row>
)}

{group.map((row, rIndex) => {
                const status = this.state.statuses.find(s => s.status === row.status);

                  if (!status) return null;
                  if (
                    status.departaments &&
                    this.state.user.departmentId &&
                    !status.departaments.includes(this.state.user.departmentId)
                  ) return null;

                  const agentId = row["usr_" + row.status];
                  const { full: fullAgentName, short: agentNameShort } = this.getAgentNamePair(agentId, agentsByKey);
                  const minutes = this.minutesSince(this.getStatusStartAt(row));

                  return (
<Row
  key={row.id}
  style={{
    ...turnRow007,
    backgroundColor: (rIndex % 2 === 1) ? 'rgba(0,0,0,0.02)' : 'transparent',
    borderRadius: 8,
  }}
>
  <Col s={4} style={colNoGutter007}>
    <div className="label-table" style={cell007}>{row.name}</div>
  </Col>

  <Col s={1} style={colNoGutter007}>
    <div className="label-table" style={{ ...cell007, ...center007 }}>{row.turn}</div>
  </Col>

  <Col s={3} style={colNoGutter007}>
    <div
      className="status-label-table"
      style={{ ...cell007, ...center007, backgroundColor: status.bgcolor_status }}
    >
      {row.status_label}
    </div>
  </Col>

  <Col s={2} style={colNoGutter007}>
    <div className="label-table" style={{ ...cell007, ...center007 }}>
      {row.erp_order_id}
    </div>
    {this.renderOrderActions(row)}
  </Col>

  <Col s={2} style={colNoGutter007}>
    <div className="label-table" style={{ ...cell007, ...center007 }} title={fullAgentName}>
      {agentNameShort === 'Sin Atender' ? '' : agentNameShort}
    </div>
  </Col>                      <Col s={12} style={{ marginTop: '8px' }}>
                        <div
                          style={{
                            display: 'flex',
                            justifyContent: 'space-between',
                            alignItems: 'center',
                            minHeight: '40px',
                            flexWrap: 'wrap',
                            gap: '10px',
                          }}
                        >
                          <div style={{ flex: '1 1 600px', minWidth: 220, maxWidth: '100%' }}>
                            {(status.status === 'payed' || status.status === 'at_deliver') ? (
                              <AsyncSelect
                                cacheOptions
                                placeholder="Seleccionar"
                                isClearable
                                onChange={(value) => this.setAgent(row, rIndex, value, status.next_status)}
                                defaultOptions={this.agents}
                                loadOptions={this.promiseOptions}
                                styles={{
                                  control: (base) => ({
                                    ...base,
                                    minHeight: '34px',
                                    fontSize: '14px',
                                  }),
                                }}
                              />
                            ) : (
                              <>
                                {this.state.editingAgentRowId === row.id ? (
                                  <div
                                    className="turn-sales-person"
                                    style={{ display: 'flex', alignItems: 'center', gap: 6, minWidth: 0 }}
                                  >
                                    <div style={{ flex: '1 1 260px', minWidth: 200, maxWidth: '100%' }}>
                                      <AsyncSelect
                                        cacheOptions
                                        isClearable
                                        placeholder="Seleccionar agente"
                                        value={this.state.editingAgentOption}
                                        defaultOptions={this.agents}
                                        loadOptions={this.promiseOptions}
                                        onChange={(opt) => this.setState({ editingAgentOption: opt })}
                                        styles={{
                                          control: (base) => ({ ...base, minHeight: '34px', fontSize: '14px' }),
                                          container: (base) => ({ ...base, width: '100%' }),
                                        }}
                                      />
                                    </div>
                                    <Button small onClick={() => this.saveAgent(row)} title="Guardar">
                                      <Icon>check</Icon>
                                    </Button>
                                    <Button small className="red" onClick={this.cancelEditAgent} title="Cancelar">
                                      <Icon>close</Icon>
                                    </Button>
                                  </div>
                                ) : (
                                  <div
                                    className="turn-sales-person"
                                    style={{ display: 'flex', alignItems: 'center', gap: 8, minWidth: 0 }}
                                    title={fullAgentName}
                                  >
                                    <div style={{ flex: '1 1 auto', minWidth: 0 }}>
                                      <span>Atiende: </span>
                                      <b
                                        style={{
                                          display: 'inline-block',
                                          maxWidth: '100%',
                                          whiteSpace: 'nowrap',
                                          overflow: 'hidden',
                                          textOverflow: 'ellipsis',
                                          verticalAlign: 'bottom',
                                        }}
                                      >
                                        {fullAgentName || 'Sin Atender'}
                                      </b>
                                    </div>

                                    {this.canEditAgent(row) && (
                                      <Button
  flat
  small
  className="edit-agent-btn"
  onClick={() => this.startEditAgent(row)}
  title="Editar agente (Almacén)"
  style={{
    minWidth: 34,
    height: 34,
    lineHeight: '34px',
    padding: 0,
    borderRadius: 10,
  }}
>
  <Icon className="edit-agent-icon">edit</Icon>
</Button>
                                    )}
                                  </div>
                                )}
                              </>
                            )}
                          </div>

                          <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                            <div className="label-table" style={{ display: 'flex', alignItems: 'center' }}>
                              <Icon className="darker" style={{ marginRight: 4 }}>timer</Icon>
                              {minutes} min
                            </div>

                            {(this.state.user?.departmentId === '007' ||
                              ['almacen2'].includes(String(this.state.user?.username || '').toLowerCase())
                            ) && (
                              <>
                                <Button
                                  node="button"
                                  floating
                                  small
                                  className="blue"
                                  style={{ width: 40, height: 40, padding: 0, borderRadius: '50%' }}
                                  disabled={row.hide_action || this.state.advancingTurnos[row.id]}
                                  onClick={() => this.handleNextStepWithLoading(row, rIndex, status.next_status)}
                                  title="Avanzar"
                                  aria-label="Avanzar"
                                >
                                  {this.state.advancingTurnos[row.id] ? (
                                    <Icon className="spin">autorenew</Icon>
                                  ) : (
                                    <Icon>send</Icon>
                                  )}
                                </Button>

                                <Button
                                  node="button"
                                  floating
                                  small
                                  className="red"
                                  style={{ width: 40, height: 40, padding: 0, borderRadius: '50%' }}
                                  disabled={row.hide_action}
                                  onClick={() => this.cancelStep(row, rIndex)}
                                  title="Cancelar"
                                  aria-label="Cancelar"
                                >
                                  <Icon>close</Icon>
                                </Button>

                                <Button
                                  node="button"
                                  floating
                                  small
                                  className="orange"
                                  style={{ width: 40, height: 40, padding: 0, borderRadius: '50%' }}
                                  onClick={() => this.togglePause(row, rIndex)}
                                  title={row.status === 'paused' ? 'Reanudar' : 'Pausar'}
                                  aria-label={row.status === 'paused' ? 'Reanudar' : 'Pausar'}
                                >
                                  <Icon>{row.status === 'paused' ? 'play_arrow' : 'pause'}</Icon>
                                </Button>
                              </>
                            )}
                          </div>
                        </div>
                      </Col>
                    </Row>
                  );
                })}
              </Col>
            ))
            : this.state.statuses.map((status, sIdx) => {
              return (
                (!checkinsByStatusToUse[status["status"]])
                  ? null
                  : checkinsByStatusToUse[status["status"]].map((row, index) => {
                    if (status["departaments"] && status["departaments"].length > 0 && this.state.user.departmentId) {
                      if (status["departaments"].indexOf(this.state.user.departmentId) === -1) {
                        console.log(" Status oculto por departamentId:", {
                          status: status["status"],
                          usuario: this.state.user.username,
                          departmentId: this.state.user.departmentId,
                          permitidos: status["departaments"]
                        });
                        return null;
                      }
                    }

                    if (!row["erp_order_id"]) row["erp_order_id"] = '';
                    if (!row["hide_action"]) row["hide_action"] = false;

                    const currentTime = this.minutesSince(this.getStatusStartAt(row));
                    let xl = 4;
                    let l = 6;
                    let s = 12;

                    return (
                      <Col key={row.id} className="column-separator" xl={xl} l={l} s={s}>
                        <Row>
                          <Col xl={6} s={5}>
                            <Row>
                              <Col s={12}>
                                <Row>
                                  <div className={"turn-name"}>
                                    <span>{row["name"]}</span>
                                  </div>
                                </Row>

                                <Row>
                                  <div className={"turn-timer"}>
                                    <span>
                                      <Icon className={"darker"}>timer</Icon>&nbsp;
                                      {currentTime} min
                                    </span>
                                  </div>
                                </Row>

                                <Row>
                                  <div className={"turn-number"}>
                                    Turno:&nbsp;<span>{row["turn"]}</span>
                                  </div>
                                </Row>

                                <Row>
                                  {(status["status"] === "payed" || status["status"] === "at_deliver") ? (
                                    <div className="turn-sales-person">
                                      <AsyncSelect
                                        cacheOptions
                                        placeholder="Seleccionar"
                                        isClearable
                                        onChange={(value) => { this.setAgent(row, index, value, status["next_status"]) }}
                                        defaultOptions={this.agents}
                                        loadOptions={this.promiseOptions}
                                      />
                                    </div>
                                  ) : (
                                    <div className="turn-sales-person">
                                      Atiende:&nbsp;
                                      <span>
                                        {(!row["usr_" + status["status"]])
                                          ? 'Sin Atender'
                                          : (agentsByKey[row["usr_" + status["status"]]])
                                            ? agentsByKey[row["usr_" + status["status"]]]["name"]
                                            : row["usr_" + status["status"]]}
                                      </span>
                                    </div>
                                  )}
                                </Row>
                              </Col>
                            </Row>
                          </Col>

                          <Col xl={3} s={3}>
                            <div
                              className={"turn-status"}
                              style={{ backgroundColor: status["bgcolor_status"] }}
                            >
                              {status.status === "transferencia" ? (
                                <>
                                  <Icon className="white-text" style={{ verticalAlign: 'middle', fontSize: '18px' }}>swap_horiz</Icon>&nbsp;
                                  <span className="white-text">Transf.</span>
                                </>
                              ) : status["label"]}
                            </div>
                          </Col>

                          {row.status !== 'arrive' && (
                            <Col xl={3} s={2}>
                              {
                                (
                                  ['creating_order', 'payed'].includes(row.status) &&
                                  ['003', '004', '005', '006', '002'].includes(this.state.user.departmentId)
                                ) ||
                                (
                                  row.status === 'paying' &&
                                  ['004', '006', '003'].includes(this.state.user.departmentId) &&
                                  !row.erp_order_id?.toLowerCase().startsWith('p')
                                )
                                  ? (
                                    <TextInput
                                      id={"nameCustomer_" + row.id}
                                      s={12}
                                      value={row["erp_order_id"]}
                                      label={row.status === 'paying' ? '' : 'Pedido'}
                                      onChange={(e) => this.setOrder(row, index, e.target.value)}
                                    />
                                  )
                                  : (
                                    <div>
                                      <div
                                        className={
                                          "turn-order" +
                                          (row.erp_order_id?.toUpperCase().startsWith("PC") ? ' consolidated-order' : '')
                                        }
                                        style={{ backgroundColor: row.status === 'paused' ? '#000000' : status["bgcolor_order"] }}
                                      >
                                        <div>
                                          <b>
                                            {row.status === 'paused'
                                              ? (row.paused_comment && row.paused_comment.trim() !== ''
                                                ? row.paused_comment.replace(/_/g, ' ').toUpperCase()
                                                : 'PAUSADO')
                                              : row.erp_order_id?.toUpperCase()}
                                          </b>
                                          
                                          {row.is_pinned ? <span style={{ marginLeft: 6 }} role="img" aria-label="pin">📌</span> : null}
                                        </div>
                                      </div>

                                      {this.renderOrderActions(row)}
                                    </div>
                                  )
                              }
                            </Col>
                          )}

                          <Col s={2}>
                            <div style={{
                              display: 'flex',
                              flexDirection: 'column',
                              alignItems: 'center',
                              justifyContent: 'center',
                              gap: '8px',
                              minHeight: '120px'
                            }}>
                              <Button
                                node="button"
                                disabled={row['hide_action'] || this.state.advancingTurnos[row.id]}
                                id={`nextStep_${row.id}`}
                                onClick={() => this.handleNextStepWithLoading(row, index, status['next_status'])}
                                title="Siguiente"
                                floating
                                small
                                className="blue"
                                style={{ width: 40, height: 40, padding: 0, borderRadius: '50%' }}
                                aria-label="Siguiente"
                              >
                                {this.state.advancingTurnos[row.id] ? (
                                  <Icon className="spin">autorenew</Icon>
                                ) : (
                                  <Icon>send</Icon>
                                )}
                              </Button>

                              <Button
                                node="button"
                                disabled={row['hide_action']}
                                id={`cancel_${row.id}`}
                                onClick={() => this.cancelStep(row, index)}
                                title="Cancelar"
                                floating
                                small
                                className="red"
                                style={{ width: 40, height: 40, padding: 0, borderRadius: '50%' }}
                                aria-label="Cancelar"
                              >
                                <Icon>close</Icon>
                              </Button>

                              {['004', '006', '007', '002', '003', '005'].includes(this.state.user.departmentId) && (
                                <Button
                                  node="button"
                                  id={`pause_${row.id}`}
                                  onClick={() => this.togglePause(row, index)}
                                  floating
                                  small
                                  className="orange"
                                  title={row.status === 'paused' ? 'Reanudar' : 'Pausar'}
                                  style={{ width: 40, height: 40, padding: 0, borderRadius: '50%' }}
                                  aria-label={row.status === 'paused' ? 'Reanudar' : 'Pausar'}
                                >
                                  <Icon>{row.status === 'paused' ? 'play_arrow' : 'pause'}</Icon>
                                </Button>
                              )}
                            </div>
                          </Col>
                        </Row>
                      </Col>
                    );
                  })
              );
            })
        }
      </Row>
    )
    : <LoadingView />
}


    </Col>
  </Row>
</Container>
</Modal>
      </React.Fragment>
    );
  }

}
export { ModalCheckin as default };


